import React, { FC, useEffect } from "react";
import { Layout } from "antd";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button as ShadButton } from "@/components/ui/button";
import { AUTH_STATUS, useEmbedAuth } from "@/hooks/useEmbedAuth";
import { BACKEND_URL } from "@/config/constants";

const { Content } = Layout;

export const EmbedScreen: FC = () => {
  const { status, error, isReady, isAuthenticating, isAuthenticated, hasError } = useEmbedAuth({
    backendUrl: BACKEND_URL,
  });

  useEffect(() => {
    localStorage.setItem("eigen_embed_mode", "true");
  }, []);

  return (
    <Layout className="h-screen flex items-center justify-center bg-background">
      <Content>
        <Card className="max-w-md mx-auto">
          <CardHeader>
            <CardTitle>Embed Authentication</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            {status === AUTH_STATUS.INITIALIZING && (
              <div className="text-center space-y-2">
                <p className="text-muted-foreground">Initializing...</p>
              </div>
            )}

            {isReady && (
              <div className="text-center space-y-2">
                <p className="text-muted-foreground">Waiting for authentication...</p>
              </div>
            )}

            {isAuthenticating && (
              <div className="text-center space-y-2">
                <p className="text-muted-foreground">Authenticating...</p>
              </div>
            )}

            {isAuthenticated && (
              <div className="text-center space-y-2">
                <p className="text-green-600">Authentication successful!</p>
                <p className="text-sm text-muted-foreground">Redirecting...</p>
              </div>
            )}

            {hasError && (
              <div className="text-center space-y-4">
                <p className="text-destructive">{error}</p>
                <ShadButton onClick={() => window.location.reload()}>Retry</ShadButton>
              </div>
            )}
          </CardContent>
        </Card>
      </Content>
    </Layout>
  );
};
